import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaSearch,
  FaTrash,
  FaWatchmanMonitoring,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import buildLink from "../../../urls";
import axios from "axios";
import { CompanyContext } from "../../../contexts/companyCotext";
import { IoIosWarning } from "react-icons/io";
import Loader from "../../../components/loader";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import hocStarredPage from "../../../components/hocStarredPage";
import Select from "react-select";
import Cookies from "js-cookie";
import { axiosServer } from "../../../axiosServer";

const CheckAddressWarehouse = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();
  const codePr = useRef(null);
  const upcRef = useRef(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [loading, setLoading] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [address, setAddress] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [warehouses, setWarehouses] = useState([]);

  const [loadingWarehouses, setLoadingWarehouses] = useState(true);
  const [error, setError] = useState(null);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);

  const handleWarehouseChange = (selectedOption) => {
    const warehouseId = selectedOption ? selectedOption.value : null;
    setSelectedWarehouseId(warehouseId);

    // Save to cookies for 1 day
    if (warehouseId) {
      Cookies.set("selectedWarehousecheckbin", warehouseId, { expires: 1 });
    } else {
      Cookies.remove("selectedWarehousecheckbin");
    }
  };

  const fetchfromwarehouse = async () => {
    try {
      const url = buildLink(`fetchfromwarehouse`);
      const response = await axiosServer.get(url);

      if (response.data.success) {
        setWarehouses(response.data.data || []);
        setLoadingWarehouses(false);
      } else {
        setError("Failed to fetch warehouses.");
      }
    } catch (err) {
      setError("Failed to fetch warehouses.");
    } finally {
      setLoadingWarehouses(false);
    }
  };

  useEffect(() => {
    fetchfromwarehouse();
    const savedWarehouse = Cookies.get("selectedWarehousecheckbin");
    if (savedWarehouse) {
      setSelectedWarehouseId(savedWarehouse);
    }
  }, []);
  const searchProduct = async (e) => {
    setLoadingSearch(true);
    e.preventDefault();

    const item = codePr.current.value;
    const warehouseID = selectedWarehouseId; // Get the warehouse ID from the state

    try {
      const url =
        buildLink("getWarehouseProductDetails") +
        `&product=${item}` +
        `&warehouse_id=${warehouseID}`; // Use the warehouse ID here
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          setProductInf(response.data.product);
          upcRef.current.focus();
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
          playSuccessSound();
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      playErrorSound();
      setLoadingSearch(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    setLoadingSearch(false);
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function checkAddress() {
    if (upcRef.current.value == productInf.bin_id) {
      playSuccessSound();
      setShowMessageSucc(true);
      setMessage("Correct place for this Product");
      setTimeout(() => {
        setShowMessageSucc(false);
      }, 3000);
      upcRef.current.value = "";
      codePr.current.value = "";
    } else {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("This Product shoudn't be here!");
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    codePr.current.focus();
  }, []);

  const handleTrashClick = () => {
    codePr.current.value = "";
    codePr.current.focus();
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  return (
    <>
      <div className=" h-full bg-white ">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white z-50">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Check Address</h2>
            </div>
          </div>
        </div>
        <div className="container flex flex-col gap-5">
          <form onSubmit={(e) => searchProduct(e)}>
            <div className="flex flex-col justify-center gap-3">
              {/* Product ID or SKU field */}

              {loadingWarehouses ? (
                <div className="text-center text-dbase">
                  <Loader />
                </div>
              ) : error ? (
                <p className="text-dbase">{error}</p>
              ) : (
                <div>
                  <div className="mb-1">Warehouse</div>
                  <Select
                    placeholder="Select Warehouse"
                    required
                    onChange={handleWarehouseChange}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: "7px",
                        borderColor: state.isFocused ? "grey" : "grey",
                        padding: "8px 5px",
                      }),
                    }}
                    options={
                      warehouses.length > 0
                        ? warehouses.map((warehouse) => ({
                          value: warehouse.warehouse_id,
                          label: warehouse.warehouse_name,
                        }))
                        : []
                    }
                    value={
                      selectedWarehouseId
                        ? warehouses
                          .map((warehouse) => ({
                            value: warehouse.warehouse_id,
                            label: warehouse.warehouse_name,
                          }))
                          .find(
                            (option) => option.value == selectedWarehouseId
                          )
                        : null
                    }
                    className="w-full"
                  />
                </div>
              )}
              {/* Warehouse Select and Button */}
              <div className="flex flex-row gap-3 w-full items-end">
                <div className="relative w-full">
                  <div className="mb-1">Product ID Or Sku</div>
                  <input
                    ref={codePr}
                    type="text"
                    className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                    placeholder="Product ID Or Sku"
                  />
                  <div>
                    <FaTrash
                      onClick={() => handleTrashClick()}
                      className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                    />
                  </div>
                </div>
                <button className="bg-dbase rounded-md text-white px-5 py-3 h-[50px]  flex items-center justify-center">
                  {loadingSearch ? <Loader /> : <FaSearch />}
                </button>
              </div>
            </div>
          </form>

          <div className="relative flex-1">
            <div className="mb-1">Address</div>
            <input
              ref={upcRef}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Address"
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  checkAddress();
                }
              }}
            />
          </div>

          <button
            onClick={() => checkAddress()}
            type="submit"
            className=" bg-dbase  px-3 py-3 text-white rounded-sm mt-3"
          >
            {" "}
            Check Address
          </button>
        </div>

        {productInf && (
          <div className="container">
            <div className="bg-white rounded-md shadow-md w-full px3 py-2 mt-10 ">
              <div className=" flex flex-row gap-3">
                <img src={productInf.image} alt="" className="w-48 h-64" />
                <div className=" my-auto">
                  <div className=" flex flex-col justify-center">
                    <h2>SKU: {productInf.sku}</h2>
                    <h2>Qty: {productInf.quantity}</h2>
                    <h2>Upc: {productInf.upc}</h2>
                    <h2>Address: {productInf.address}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(CheckAddressWarehouse);
